import { TuiCustomEnter } from '@taiga-ui/editor/extensions/enter';
import { TuiHorizontalRule } from '@taiga-ui/editor/extensions/horizontal';
import { Extension } from '@tiptap/core';
import { Blockquote } from '@tiptap/extension-blockquote';
import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Code } from '@tiptap/extension-code';
import { CodeBlock } from '@tiptap/extension-code-block';
import { Document } from '@tiptap/extension-document';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { Gapcursor } from '@tiptap/extension-gapcursor';
import { HardBreak } from '@tiptap/extension-hard-break';
import { Heading } from '@tiptap/extension-heading';
import { History } from '@tiptap/extension-history';
import { Italic } from '@tiptap/extension-italic';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Strike } from '@tiptap/extension-strike';
import { TaskItem } from '@tiptap/extension-task-item';
import { TaskList } from '@tiptap/extension-task-list';
import { Text } from '@tiptap/extension-text';
const TuiStarterKit = Extension.create({
  name: 'starterKit',
  addExtensions() {
    const extensions = [];
    // note: in runtime it possibly be undefined
    const options = this.options;
    if (options?.blockquote !== false) {
      extensions.push(Blockquote.configure(options?.blockquote));
    }
    if (options?.bold !== false) {
      extensions.push(Bold.configure(options?.bold));
    }
    if (options?.bulletList !== false) {
      extensions.push(BulletList.configure(options?.bulletList));
    }
    if (options?.code !== false) {
      extensions.push(Code.configure(options?.code));
    }
    if (options?.codeBlock !== false) {
      extensions.push(CodeBlock.configure(options?.codeBlock));
    }
    if (options?.document !== false) {
      extensions.push(Document.configure(options?.document));
    }
    if (options?.dropcursor !== false) {
      extensions.push(Dropcursor.configure(options?.dropcursor));
    }
    if (options?.gapcursor !== false) {
      extensions.push(Gapcursor.configure({
        allowGapCursor: true,
        ...(options?.gapcursor ?? {})
      }));
    }
    if (options?.hardBreak !== false) {
      extensions.push(HardBreak.configure(options?.hardBreak));
    }
    if (options?.heading !== false) {
      extensions.push(Heading.configure({
        levels: [1, 2, 3, 4, 5, 6],
        ...options?.heading
      }).extend({
        addKeyboardShortcuts() {
          return this.options.levels.reduce((items, level) => ({
            ...(items || {}),
            [`Mod-Alt-${level}`]: () => this?.editor.commands.toggleHeading({
              level
            })
          }), {});
        }
      }));
    }
    if (options?.history !== false) {
      extensions.push(History.configure({
        depth: 100,
        newGroupDelay: 500,
        ...options?.history
      }));
    }
    if (options?.horizontalRule !== false) {
      extensions.push(TuiHorizontalRule.configure(options?.horizontalRule));
    }
    if (options?.italic !== false) {
      extensions.push(Italic.configure(options?.italic));
    }
    if (options?.listItem !== false) {
      extensions.push(ListItem.configure(options?.listItem));
    }
    if (options?.taskList !== false) {
      extensions.push(TaskList.configure(options?.taskList));
    }
    if (options?.taskItem !== false) {
      extensions.push(TaskItem.configure({
        nested: true,
        ...options?.taskItem
      }));
    }
    if (options?.orderedList !== false) {
      extensions.push(OrderedList.configure(options?.orderedList));
    }
    if (options?.paragraph !== false) {
      extensions.push(Paragraph.configure(options?.paragraph));
    }
    if (options?.strike !== false) {
      extensions.push(Strike.configure(options?.strike));
    }
    if (options?.text !== false) {
      extensions.push(Text.configure(options?.text));
    }
    if (options?.placeholder !== false) {
      extensions.push(Placeholder.configure({
        emptyNodeClass: 't-editor-placeholder',
        includeChildren: true,
        showOnlyCurrent: true,
        showOnlyWhenEditable: true,
        placeholder: '',
        ...(options?.placeholder ?? {})
      }));
    }
    if (options?.enter !== false) {
      extensions.push(TuiCustomEnter);
    }
    return extensions;
  }
});

/**
 * Generated bundle index. Do not edit.
 */

export { TuiStarterKit };
